import * as Sentry from '@sentry/browser';
import { SENTRY_ENVIRONMENT } from 'settings';

if (SENTRY_ENVIRONMENT) {
  Sentry.init({
    environment: SENTRY_ENVIRONMENT,
    dsn: 'https://f3e6c670502342b1b9eaf96fe45380af@sentry.io/1772232',
  });
}
